import React from 'react';
import HeadTittle from '../../../../components/HeadTittle';
import { permissionObj } from '../../../../Helpers/permission';
import StepperTabs from "../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../components/StepperTabs/StepTab";
import { ButtonNextStep, ButtonPrevStep } from "../../../../components/buttons/ButtonNavigation";
import { STEPS_CREATE_WORK_SHIFT } from "./Model/Models";
import { CreateWorkShiftApp } from "./Functionality/CreateWorkShiftApp";
import SectionWorkShift from "./Subcomponents/Steps/SectionWorkShift";
import SectionCustomAccess from "./Subcomponents/Steps/SectionCustomAccess";
import SectionDepartments from "./Subcomponents/Steps/SectionDepartments";
import Summary from "./Subcomponents/Summary/Summary";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azapata@ibl.mx
 *
 * Create work shift flow (stepper: work shift schedules → custom access →
 * departments → summary). Mirrors the ShiftAccess AddShiftAccess.
 */
const CreateWorkShift = () => {

    const {
        t,
        DEV,
        permission,
        emptyFields,
        disabled,
        item,
        handleChange,

        schedules, setSchedules,
        selectDeleteSchedules, setSelectDeleteSchedules,

        departments, setDepartments,
        selectDeleteDepartments, setSelectDeleteDepartments,
        modified, setModified,
        user, setUser,
        selectDeleteUser, setSelectDeleteUser,
        searchElement,
        setSearchElement,
        steps,
        activeStep, setActiveStep,
        handleStepChange,
        handleClearStep,
        handleValidateSteps,
        handleAddEdit,
        handleOnBack,
    } = CreateWorkShiftApp();

    return (
        <>
            <HeadTittle onBack={handleOnBack} name={'create'} />

            <StepperTabs
                id={null}
                disabled={false}
                steps={steps}
                activeStep={activeStep}
                isStepOptional={() => {}}
                setActiveStep={setActiveStep}
                handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_CREATE_WORK_SHIFT.WORK_SHIFT.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_WORK_SHIFT.WORK_SHIFT.INDEX && (
                        <>
                            <SectionWorkShift
                                id={null}
                                item={item}
                                handleChange={handleChange}
                                emptyFields={emptyFields}
                                disabled={disabled}
                                handleClearStep={handleClearStep}
                                schedules={schedules}
                                setSchedules={setSchedules}
                                selectDeleteSchedules={selectDeleteSchedules}
                                setSelectDeleteSchedules={setSelectDeleteSchedules}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6'>
                                <ButtonNextStep
                                    id='btn_cws_next_work_shift'
                                    text='next'
                                    click={() => {
                                        if (handleValidateSteps(activeStep)) {
                                            setActiveStep((prev) => prev + 1);
                                        }
                                    }}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_WORK_SHIFT.CUSTOM_ACCESS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_WORK_SHIFT.CUSTOM_ACCESS.INDEX && (
                        <>
                            <SectionCustomAccess
                                id={null}
                                handleClearStep={handleClearStep}
                                user={user}
                                setUser={setUser}
                                selectDeleteUser={selectDeleteUser}
                                setSelectDeleteUser={setSelectDeleteUser}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_cws_back_custom_access'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cws_next_custom_access'
                                    text='next'
                                    click={() => setActiveStep((prev) => prev + 1)}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_WORK_SHIFT.DEPARTMENTS.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_WORK_SHIFT.DEPARTMENTS.INDEX && (
                        <>
                            <SectionDepartments
                                id={null}
                                handleClearStep={handleClearStep}
                                departments={departments}
                                setDepartments={setDepartments}
                                selectDeleteDepartments={selectDeleteDepartments}
                                setSelectDeleteDepartments={setSelectDeleteDepartments}
                                searchElement={searchElement}
                                setSearchElement={setSearchElement}
                                modified={modified}
                                setModified={setModified}
                            />
                            <div className='col-12 d-flex justify-content-between mt-3'>
                                <ButtonPrevStep
                                    id='btn_cws_back_departments'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cws_next_departments'
                                    text='next'
                                    click={() => setActiveStep((prev) => prev + 1)}
                                />
                            </div>
                        </>
                    )}
                </StepTab>

                <StepTab index={STEPS_CREATE_WORK_SHIFT.SUMMARY.INDEX} activeStep={activeStep}>
                    {activeStep === STEPS_CREATE_WORK_SHIFT.SUMMARY.INDEX && (
                        <>
                            <Summary
                                t={t}
                                item={item}
                                schedules={schedules}
                                user={user}
                                departments={departments}
                            />
                            <div className='d-flex justify-content-between px-0 mb-2 mt-3'>
                                <ButtonPrevStep
                                    id='btn_cws_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prev) => prev - 1)}
                                />
                                {(DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_CREATE)) &&
                                    <ButtonNextStep
                                        id='btn_cws_create_work_shift'
                                        text='create'
                                        click={() => handleAddEdit()}
                                    />
                                }
                            </div>
                        </>
                    )}
                </StepTab>
            </StepperTabs>
        </>
    );
}

export default CreateWorkShift
